import React, { Component } from "react";
import LoaderImg from "../css/superlogo.gif";
import NoDataImg from "../css/pngwingImg.png";
import mainImg from "../css/marveliu.jpg";
import {
  Grid,
  Container,
  CssBaseline,
  TablePagination,
} from "@material-ui/core";
import Fade from "react-reveal/Fade";
import Navigate from "../config/navbar";
import "./home.css";

class Home extends Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
      shadow: 1,
      left: false,
      anchorEl: null,
      items: [],
      page: 0,
      rowsPerPage: 25,
      intervalId: 0,
      offline: false,
      isDisconnected: false,
      loadingData: false,
    };
  }

  /*************************************************/
  handleChangePage = (event, page) => {
    this.setState({ page });
    document.getElementById("scroll-here-plz").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
    // this.scrollToTop();
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  // scrollStep() {
  //   if (window.pageYOffset === 0) {
  //     clearInterval(this.state.intervalId);
  //   }
  //   window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
  // }
  // scrollToTop() {
  //   let intervalId = setInterval(this.scrollStep.bind(this), "0");
  //   this.setState({ intervalId: intervalId });
  // }
  /*************************************************/

  handleChange = (event, value) => {
    this.setitemName({ value });
  };

  handleChangeIndex = (index) => {
    this.setitemName({ value: index });
  };

  /*************************************************/

  componentDidMount() {
    this.getDataFromApi();
    this.handleConnectionChange();
    window.addEventListener("online", this.handleConnectionChange);
    window.addEventListener("offline", this.handleConnectionChange);
  }
  componentWillUnmount() {
    window.removeEventListener("online", this.handleConnectionChange);
    window.removeEventListener("offline", this.handleConnectionChange);
  }

  getDataFromApi = () => {
    this.setState({
      loadingData: true,
    });
    fetch("https://akabab.github.io/superhero-api/api/all.json")
      // fetch("https://www.superheroapi.com/api.php/2849691101757025")
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result,
            loadingData: false,
          });
          setTimeout(
            () => localStorage.setItem("savedData", JSON.stringify(result)),

            1000
          );
          // console.log(result);
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          this.setState({
            isLoaded: true,
            error,
          });
        }
      );
  };

  handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition === "online") {
      const webPing = setInterval(() => {
        fetch("https://www.google.com/", {
          // Check for internet connectivity
          mode: "no-cors",
        })
          .then(() => {
            this.setState({ isDisconnected: false }, () => {
              return clearInterval(webPing);
            });
          })
          .catch((error) => console.log(error));
      }, 2000);
      return;
    }

    return this.setState({ isDisconnected: true });
  };
  search = (e) => {
    const textSearch = e.target.value;
    var objectsData = JSON.parse(localStorage.getItem("savedData"));
    const result = objectsData.filter((elem) => {
      return elem.name.toLowerCase().indexOf(textSearch) >= 0;
    });
    this.setState({
      result,
      textSearch,
    });
  };

  clickTellMeMore = () => {
    document.getElementById("scroll-here-plz").scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });
  };
  render() {
    const {
      result,
      textSearch,

      items,
      rowsPerPage,
      page,
      loadingData,
      isDisconnected,
    } = this.state;
    localStorage.setItem("savedData", JSON.stringify(items));
    var objectsData = items && JSON.parse(localStorage.getItem("savedData"));

    const asd = textSearch ? result : objectsData;

    return (
      <div>
        <Navigate />
        {loadingData === true ? (
          <div id="loadingOverlay" className="loader-overlay">
            <div className="loader-content loader-center">
              {/* <div className="loader-center loader-text">Loading, please wait...</div> */}
              <img src={LoaderImg} alt="" />
            </div>
          </div>
        ) : (
          <div id="">
            {/* <header className="masthead" style={{  padding-top: 10.5rem; */}
            <header
              className="masthead"
              style={{
                paddingTop: "10.5rem",
                paddingBottom: "6rem",
                textAlign: "center",
                color: "#fff",
                backgroundImage: `url(${mainImg})`,
                backgroundRepeat: "no-repeat",
                backgroundAttachment: "scroll",
                backgroundPosition: "center center",
                backgroundSize: "cover",
              }}
            >
              <div className="container">
                <div
                  className="masthead-subheading"
                  style={{
                    fontFamily: "TimberwolfRegular",
                    letterSpacing: "15px",
                    fontSize: "30px",
                  }}
                >
                  Welcome!
                </div>
                <div
                  className="masthead-heading text-uppercase"
                  style={{
                    fontFamily: "TimberwolfRegular",
                    letterSpacing: "15px",
                  }}
                >
                  It's All About Super Heroes
                </div>
                <button
                  style={{
                    fontFamily: "TimberwolfRegular",
                    letterSpacing: "15px",
                  }}
                  className="btn btn-primary text-dark btn-xl text-uppercase"
                  // href="#services"
                  onClick={() => this.clickTellMeMore()}
                >
                  Show me
                </button>
              </div>
            </header>
            <CssBaseline />
            <div />
            <div />
            <Container maxWidth="lg">
              <br />
              <Fade left when={isDisconnected}>
                {isDisconnected && (
                  <div className="alert alert-success" role="alert">
                    <h4 className="alert-heading">Warning!</h4>
                    <p>Internet Disconnect — You are in offline mode!</p>
                    <hr />
                    {/* <p className="mb-0">
                      Whenever you need to, be sure to use margin utilities to
                      keep things nice and tidy.
                    </p> */}
                  </div>
                )}
              </Fade>

              <div className="text-center mt-5">
                <h2
                  className="section-heading text-uppercase"
                  id="scroll-here-plz"
                  style={{
                    fontFamily: "TimberwolfRegular",
                    letterSpacing: "15px",
                  }}
                >
                  HEROES LIST
                </h2>
                <h3
                  className="section-subheading text-muted"
                  style={{
                    fontFamily: "TimberwolfRegular",
                    letterSpacing: "15px",
                    fontSize: "30px",
                  }}
                >
                  All Heroes (Marvel and DC)
                </h3>
              </div>
              <div>
                <br />
                <br />
                <br />
                <div className="">
                  <div className="row d-flex justify-content-between align-items-center">
                    <div className="col-xs-12 col-sm-6">
                      <div className="form-group">
                        <input
                          className="form-control"
                          id="name"
                          type="text"
                          placeholder="Search Heroes"
                          // data-sb-validations="required"
                          onChange={this.search.bind(this)}
                        />
                        <div
                          className="invalid-feedback"
                          data-sb-feedback="name:required"
                        >
                          A name is required.
                        </div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-6">
                      {asd.length ? (
                        <TablePagination
                          rowsPerPageOptions={[10, 25, 50, 100]}
                          component="div"
                          count={asd.length}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          onChangePage={this.handleChangePage}
                          onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <br />
                <br />
                <div>
                  <Grid
                    container
                    // spacing={2}
                    direction="row"
                    justify="flex-start"
                    alignItems="flex-start"
                  >
                    {asd.length !== 0 ? (
                      asd
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((elem, index) => {
                          return (
                            <Grid
                              item
                              xs={12}
                              sm={4}
                              md={3}
                              key={index}
                              id={elem.id}
                            >
                              <div className="cards">
                                <div className="card">
                                  <h2 className="card-title">{elem.name}</h2>
                                  <img src={elem.images.lg} alt="" />
                                  <div className="card-desc">
                                    <p>
                                      Connections:{" "}
                                      {elem.connections.groupAffiliation}
                                    </p>
                                    <br />
                                    <p>
                                      Relatives: {elem.connections.relatives}
                                    </p>
                                    <br />
                                    <p>Publisher: {elem.biography.publisher}</p>
                                    <br />
                                    <p>
                                      First Appearance:{" "}
                                      {elem.biography.firstAppearance}
                                    </p>
                                    <br />
                                  </div>
                                </div>
                              </div>
                            </Grid>
                          );
                        })
                    ) : (
                      <div className="container h-100">
                        <div className="row align-items-center h-100">
                          <div className="col-6 mx-auto">
                            <div className="h-100  justify-content-center">
                              {/* <div className="row text-center"> */}
                              <div className="col-12">
                                <img
                                  className="img-fluid"
                                  src={NoDataImg}
                                  alt=""
                                  style={{
                                    // height: "450px",
                                    // width: "450px",
                                    margin: "0 auto",
                                  }}
                                />
                                <div className="jumbotron">
                                  <h4
                                    className="display-4"
                                    style={{
                                      color: "black",
                                      textAlign: "center",
                                    }}
                                  >
                                    No Super Hero Available
                                  </h4>
                                </div>
                              </div>
                              {/* </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </Grid>
                </div>
                {asd.length ? (
                  <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    component="div"
                    count={asd.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                ) : (
                  ""
                )}
              </div>
            </Container>
            {/* <section className="page-section" id="contact">
              <div className="container">
                <div className="text-center">
                  <h2 className="section-heading text-uppercase">Contact Us</h2>
                  <h3 className="section-subheading text-muted">
                    Lorem ipsum dolor sit amet consectetur.
                  </h3>
                </div>
              </div>
            </section> */}
            <footer className="footer py-4">
              <div className="container">
                <div className="row justify-content-between align-items-center">
                  <div
                    className="col-lg-4 text-lg-start"
                    style={{
                      fontFamily: "TimberwolfRegular",
                      // letterSpacing: "15px",
                      fontSize: "30px",
                    }}
                  >
                    Copyright &copy; Eight-1-Eight {new Date().getFullYear()}
                  </div>
                  <div className="col-lg-4 my-3 my-lg-0">
                    <a
                      className="btn btn-dark btn-social mx-2"
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://twitter.com/AdnanAhmed_818"
                    >
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a
                      className="btn btn-dark btn-social mx-2"
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.facebook.com/millions818"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a
                      className="btn btn-dark btn-social mx-2"
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.linkedin.com/in/adnan-ahmed-28160298/"
                    >
                      <i className="fab fa-linkedin-in"></i>
                    </a>
                  </div>
                  {/* <div className="col-lg-4 text-lg-end">
                <a className="link-dark text-decoration-none me-3" href="#!">
                  Privacy Policy
                </a>
                <a className="link-dark text-decoration-none" href="#!">
                  Terms of Use
                </a>
              </div> */}
                </div>
              </div>
            </footer>
          </div>
        )}
      </div>
    );
  }
}

export default Home;
